import { lazy } from 'react';

export const LazyPage404 = lazy(() => import('./404/Page404'));

export const LazyHomePage = lazy(() => import('../pages/HomePage/HomePage'));
export const LazyAdminPage = lazy(() => import('./AdminPage/AdminPage'));
